import { callApi } from 'utils/api';

/**
 * @return {Promise<Array>}
 */
export const fetchTermsAndConditionsApi = () => {
  const language = window.navigator.language.slice(0, 2);
  return callApi(`website/terms?lang=${language}`);
};
